// extracted by mini-css-extract-plugin
export default {"heading":"u8M13aUO--styles_heading__1AEO0","card":"u8M13aUO--styles_card__VXO7Z","submitButton":"u8M13aUO--styles_submitButton__7IBYR","shimmer":"u8M13aUO--styles_shimmer__zPMaI"};